import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from './i18n';
import VueCarousel from "./carousel";

//const VueGoogleMaps = require('./vue2-google-maps');

//const VueCarousel = require('./vue-carousel');


//import LanguageSwitcher from "./components/LanguageSwitcher";

Vue.config.productionTip = false;
new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
i18n.locale = 'es'